import ApplicationModel, { attr } from '../ApplicationModel';
import { type BusinessModelComponentAttributes } from './generated/BusinessModelComponentAttributes';
import { model } from '../modelBuilder';

interface BusinessModelComponent extends BusinessModelComponentAttributes {}

@model
class BusinessModelComponent extends ApplicationModel {
  // Start auto-generated
  static typename: 'BusinessModelComponent' = 'BusinessModelComponent';
  get typename(): 'BusinessModelComponent' {
    return 'BusinessModelComponent';
  }

  static internalTypename: 'BusinessModelComponent' = 'BusinessModelComponent';
  get internalTypename(): 'BusinessModelComponent' {
    return 'BusinessModelComponent';
  }

  static fields = {
    id: attr({ readable: true }),
    name: attr({ readable: true }),
  };
  // End auto-generated
}

export default BusinessModelComponent;
